import { Info } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

import FormField from "common/components/ui/FormField";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectItemText,
  SelectTrigger,
  SelectValue,
} from "common/components/ui/Select";
import SelectButton from "common/components/ui/SelectButton";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import { typedObjectEntries } from "common/helpers/utils";
import type { KeywordTypes } from "common/types";

import { KEYWORD_OPTIONS } from "../../../../../../constants";

interface KeywordTypeSelectProps {
  selectedKeywordType: KeywordTypes;
  setSelectedKeywordType: (keyword: KeywordTypes) => void;
  isDisabled: boolean;
}

export default function KeywordTypeSelect({
  selectedKeywordType,
  setSelectedKeywordType,
  isDisabled,
}: KeywordTypeSelectProps) {
  const { t } = useTranslation("campaigns", {
    keyPrefix: "targetingSetup",
  });

  return (
    <FormField
      label="Keyword type"
      htmlFor="keywordTypeSelect"
      extraLabelComponent={
        <Tooltip>
          <TooltipTrigger>
            <Info size={16} weight="fill" className="fill-black-300" />
          </TooltipTrigger>
          <TooltipContent side="bottom">{t("keywordsTooltip")}</TooltipContent>
        </Tooltip>
      }
    >
      <Select
        value={selectedKeywordType}
        onValueChange={setSelectedKeywordType}
        disabled={isDisabled}
      >
        <SelectTrigger className="min-w-[120px] lg:w-[280px]" asChild>
          <SelectButton hasSelection={!!selectedKeywordType}>
            <SelectValue />
          </SelectButton>
        </SelectTrigger>
        <SelectContent>
          {typedObjectEntries(KEYWORD_OPTIONS).map(([key, { label }]) => (
            <SelectItem value={key} key={key}>
              <SelectItemText>{label}</SelectItemText>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormField>
  );
}
